<app-kpi-widget
  [title]="'driverOverview.widgets.trips' | transloco"
  [isLoading]="isLoading"
  [icon]="'ph-road-horizon'"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [difference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [differenceFormatter]="formatDifference.bind(this)"
  (clicked)="openTripsModal()"
  [isImageIcon]="false"
  [widgetDisabled]="false"
  [hasFooter]="false"
  [dropdownEnabled]="false">
</app-kpi-widget>